import { exportSurveyResultToFile } from "@/lib/export/crm/salesforce/exportSurveyToFile";
import { CrmSystem } from "../../_core/crmSystem";
import { CheckboxForm, CurrencyForm, DateForm, NumberForm, SliderForm, TextForm, BooleanForm } from "../_common/FieldForm";
import { BooleanRenderer, CheckboxRenderer, CurrencyRenderer, NumberRenderer, RadioRenderer, TextRenderer, TextareaRenderer, PickListRenderer, PickListMultipleRenderer } from "../_common/FieldRenderer";
import { booleanParser, dateParser, numberParser, semicolonListParser, stringParser } from "../_common/useGetExportData/parser/_core";
import { DateRenderer, SliderRenderer } from "./FieldRenderer";

class SalesforceCrmSystem extends CrmSystem<'salesforce'> {
    id = "salesforce" as const;
    name = "Salesforce";
    branding = {
        color: '#0D9DDA',
        logoUrl: undefined
    };
    exportHandler = exportSurveyResultToFile;
    fieldTypes = {
        'text': {
            formComponent: TextForm,
            rendererComponent: TextRenderer,
            name: 'Text',
            id: 'text',
            parser: stringParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'text',
                'airtable': 'singleLineText'
            },
            baseType: 'text'
        } as const,
        'textarea': {
            formComponent: TextForm,
            rendererComponent: TextareaRenderer,
            name: 'Textarea',
            id: 'textarea',
            parser: stringParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'textarea',
                'airtable': 'multilineText'
            },
            baseType: 'text'
        } as const,
        'number': {
            formComponent: NumberForm,
            rendererComponent: NumberRenderer,
            name: 'Number',
            id: 'number',
            parser: numberParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'number',
                'airtable': 'number'
            },
            baseType: 'number'
        } as const,
        'currency': {
            formComponent: CurrencyForm,
            rendererComponent: CurrencyRenderer,
            name: 'Currency',
            id: 'currency',
            parser: numberParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'currency',
                'airtable': 'currency'
            },
            baseType: 'number'
        } as const,
        'slider': {
            formComponent: SliderForm,
            rendererComponent: SliderRenderer,
            name: 'Slider',
            id: 'slider',
            parser: numberParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'slider',
                'airtable': 'number'
            },
            baseType: 'number'
        } as const,
        'radio': {
            formComponent: CheckboxForm,
            rendererComponent: RadioRenderer,
            name: 'Radio',
            id: 'radio',
            parser: stringParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'radio',
                'airtable': 'singleSelect'
            },
            baseType: 'text'
        } as const,
        'checkbox': {
            formComponent: CheckboxForm,
            rendererComponent: CheckboxRenderer,
            name: 'Checkbox',
            id: 'checkbox',
            parser: semicolonListParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'checkbox',
                'airtable': 'multipleSelects'
            },
            baseType: 'list'
        } as const,
        'picklist': {
            formComponent: CheckboxForm,
            rendererComponent: PickListRenderer,
            name: 'Picklist',
            id: 'picklist',
            parser: stringParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'picklist',
                'airtable': 'singleSelect'
            },
            baseType: 'text'
        } as const,
        'picklist_multiple': {
            formComponent: CheckboxForm,
            rendererComponent: PickListMultipleRenderer,
            name: 'Picklist Multiple',
            id: 'picklist_multiple',
            parser: semicolonListParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'picklist_multiple',
                'airtable': 'multipleSelects'
            },
            baseType: 'list'
        } as const,
        'boolean': {
            formComponent: BooleanForm,
            rendererComponent: BooleanRenderer,
            name: 'Boolean',
            id: 'boolean',
            parser: booleanParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'boolean',
                'airtable': 'checkbox'
            },
            baseType: 'boolean'
        } as const,
        'date': {
            formComponent: DateForm,
            rendererComponent: DateRenderer,
            name: 'Date',
            id: 'date',
            parser: dateParser,
            otherCrmSystemEquivalent: {
                'collaborate': 'date',
                'airtable': 'date'
            },
            baseType: 'number'
        } as const,


    };
}

export const salesforceCrmSystem = new SalesforceCrmSystem();